import React from "react";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

export default function DashboardNotificationsButton({ count = 0, onClick }) {
    return (
        <Tooltip
            title="Notifications"
            slotProps={{
                tooltip: {
                    sx: {
                        borderRadius: "10px",
                        backgroundColor: "rgba(0, 40, 128, 0.88)",
                        backdropFilter: "blur(8px)",
                        WebkitBackdropFilter: "blur(8px)",
                        fontWeight: 400,
                        letterSpacing: "0.02em",
                        px: 1.5,
                        py: 0.7,
                        fontSize: "0.8rem",
                    },
                },
            }}
        >
            <IconButton
                aria-label="notifications"
                onClick={onClick}
                sx={{
                    borderRadius: "12px",
                    border: "1px solid rgba(255, 144, 21, 0.18)",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    boxShadow:
                        "0 4px 16px rgba(255, 144, 21, 0.08), 0 1px 3px rgba(0, 40, 128, 0.04)",
                    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "rgba(255, 144, 21, 0.08)",
                        boxShadow:
                            "0 8px 24px rgba(255, 144, 21, 0.16), 0 2px 6px rgba(0, 40, 128, 0.06)",
                        border: "1px solid rgba(255, 144, 21, 0.32)",
                    },
                    "&:active": {
                        transform: "scale(0.97)",
                    },
                }}
            >
                <Badge
                    color="error"
                    variant={count ? "standard" : "standard"}
                    badgeContent={count || 0}
                    invisible={!count}
                    sx={{
                        "& .MuiBadge-badge": {
                            fontWeight: 600,
                            fontSize: "0.7rem",
                            minWidth: 18,
                            height: 18,
                            borderRadius: "9px",
                            boxShadow: count
                                ? "0 2px 8px rgba(211, 47, 47, 0.4)"
                                : "none",
                            background: count
                                ? "#d32f2f"
                                : undefined,
                            transition:
                                "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            animation: count
                                ? "badgePulse 2s ease-in-out infinite"
                                : "none",
                        },
                        "@keyframes badgePulse": {
                            "0%, 100%": {
                                boxShadow:
                                    "0 2px 8px rgba(211, 47, 47, 0.4)",
                            },
                            "50%": {
                                boxShadow:
                                    "0 2px 16px rgba(211, 47, 47, 0.6)",
                            },
                        },
                    }}
                >
                    <NotificationsOutlinedIcon
                        sx={{
                            color: "#002880",
                            fontSize: 22,
                            transition:
                                "color 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                    />
                </Badge>
            </IconButton>
        </Tooltip>
    );
}
